import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchProduct(params) {
  return await request({
    url: ENDPOINT.HOME_PRODUCT_SERIVICE_TRYING,
    method: "get",
    params,
  });
}

export async function fetchProductById(id) {
  return await request({
    url: `${ENDPOINT.HOME_PRODUCT_SERIVICE_TRYING}/${id}`,
    method: "get",
  });
}

export async function createProduct(data) {
  return await request({
    url: ENDPOINT.HOME_PRODUCT_SERIVICE_TRYING,
    method: "post",
    data,
  });
}

export async function updateProduct(id, data) {
  return await request({
    url: `${ENDPOINT.HOME_PRODUCT_SERIVICE_TRYING}/${id}`,
    method: "put",
    data,
  });
}

export async function deleteProduct(id) {
  return await request({
    url: `${ENDPOINT.HOME_PRODUCT_SERIVICE_TRYING}/${id}`,
    method: "delete",
  });
}